export function areDatesEqual(date1: Date | null, date2: Date | null): boolean {
  if (!date1 || !date2) return false;

  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
}

export function getDateAsString(date: Date): string {
  let month = (date.getMonth() + 1).toString();
  let day = date.getDate().toString();

  if (month.length === 1) {
    month = '0' + month;
  }

  if (day.length === 1) {
    day = '0' + day;
  }

  return `${date.getFullYear()}-${month}-${day}T00:00:00.000Z`;
}

export function formatDateTimeAsEuropeanFormat(dateStr: string): string {
  const date = new Date(dateStr);
  return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
};

export function formatTime(dateStr: string): string {
  const date = new Date(dateStr);
  return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
};

export function formatDateAsEuropeanFormat(dateStr: string): string {
  const date = new Date(dateStr);
  return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
};

export function getRemainingDays(date1: Date, date2: Date) {
  date1 = new Date(date1.toISOString().slice(0, 10));
  date2 = new Date(date2.toISOString().slice(0, 10));
  const diffTime = Math.abs(date2.getTime() - date1.getTime());
  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
}
export function getDateUtcFromString(dateString: string): Date {
  dateString = dateString.split('T')[0];

  const arrDate = dateString.split('-').map((v: string, i: number) => {
    let vNum = parseInt(v);

    return i === 1 ? vNum - 1 : vNum;
  });

  return new Date(arrDate[0], arrDate[1], arrDate[2], 0, 0, 0, 0);
}

